// extracted by mini-css-extract-plugin
export var messageSideLeft = "_q6-1";
export var stateContainer = "_q6-0";